import {applyMiddleware, combineReducers, compose, createStore} from "redux";
import thunk from "redux-thunk";

import {publicReducer} from "../public/reducer";
import {loadingReducer} from "../loading/reducer";
import {splashReducer} from "../splash/reducer";
import {userInfoReducer} from "../user/reducer";
import {dashboardReducer} from "../dashboard/reducer";
import {senderReducer} from "../singleOrder/sender/reducer";
import {receiverReducer} from "../singleOrder/receiver/reducer";
import {infoBoxReducer} from "../singleOrder/infoBox/reducer";
import {reviewReducer} from "../singleOrder/review/reducer";
import {servicesReducer} from "../singleOrder/services/reducer";
import {multiSenderReducer} from "../multiOrder/sender/reducer";
import {multiReceiverReducer} from "../multiOrder/receiver/reducer";
import {multiInfoBoxReducer} from "../multiOrder/infoBox/reducer";


export const reducer = combineReducers({
  public: publicReducer,
  loading: loadingReducer,
  splash: splashReducer,
  userInfo: userInfoReducer,
  dashboard: dashboardReducer,

  single_sender: senderReducer,
  single_receiver: receiverReducer,
  single_info_box: infoBoxReducer,
  single_services: servicesReducer,
  single_review: reviewReducer,

  multi_sender: multiSenderReducer,
  multi_receiver: multiReceiverReducer,
  multi_info_box: multiInfoBoxReducer,
});

export function configureStore(initialState = {}) {
  return compose(applyMiddleware(thunk))(createStore)(reducer, initialState);
}

export const store = configureStore();
